module.exports = __webpack_public_path__ + "img/empowering.fbc6b95b.svg";